module.exports = __webpack_public_path__ + "static/media/live-reports.73ae3139.png";